import { _ as _ts_decorate } from "@swc/helpers/_/_ts_decorate";
import { _ as _ts_metadata } from "@swc/helpers/_/_ts_metadata";
import { observable, runInAction, set } from "mobx";
import { getSanitizedControlValue, getSidebarCustomize } from "@devowl-wp/customize";
class BannerPreset {
    constructor(preset, store){
        runInAction(()=>set(this, preset));
        this.store = store;
    }
    static getIframeStore() {
        try {
            return document.querySelector("#customize-preview > iframe").contentWindow.realCookieBanner_customize_banner.RootStore.get;
        } catch (e) {
            // Element does not yet exist
            return undefined;
        }
    }
    applyInUi() {
        // Check if pro
        if (!this.store.rootStore.optionStore.others.isPro && this.needsPro) {
            return false;
        }
        const customize = getSidebarCustomize();
        // First, save all in our store so the paint is done correctly
        this.previewInUi();
        // Afterwards, save in customize state
        setTimeout(()=>{
            this.store.presetDefaults.forEach((defaultValue, key)=>{
                const setting = customize(key);
                // Apply it
                setting.set(this.settings[key] === undefined ? defaultValue : this.settings[key]);
            });
        }, 100);
        return true;
    }
    previewInUi() {
        const { presetDefaults } = this.store;
        const { settings } = this.store.rootStore.optionStore.others.customizeIdsBanner;
        const batchUpdates = [];
        // Make it restorable
        this.resetPreviewInUiSettings = {};
        for (const section of Object.keys(settings)){
            const sectionSettings = settings[section];
            for (const setting of Object.keys(sectionSettings)){
                const customizeKey = sectionSettings[setting];
                if (!presetDefaults.has(customizeKey)) {
                    continue;
                }
                const val = getSanitizedControlValue(customizeKey, presetDefaults.get(customizeKey));
                if (val !== null) {
                    this.resetPreviewInUiSettings[customizeKey] = [
                        section,
                        setting,
                        val
                    ];
                    const newValue = Object.prototype.hasOwnProperty.call(this.settings, customizeKey) ? this.settings[customizeKey] : presetDefaults.get(customizeKey);
                    batchUpdates.push([
                        section,
                        setting,
                        newValue
                    ]);
                }
            }
        }
        BannerPreset.getIframeStore().customizeBannerStore.setBannerFromPreset(batchUpdates);
    }
    resetPreviewInUi() {
        if (this.resetPreviewInUiSettings) {
            BannerPreset.getIframeStore().customizeBannerStore.setBannerFromPreset(Object.values(this.resetPreviewInUiSettings));
            this.resetPreviewInUiSettings = {};
        }
    }
}
_ts_decorate([
    observable,
    _ts_metadata("design:type", String)
], BannerPreset.prototype, "id", void 0);
_ts_decorate([
    observable,
    _ts_metadata("design:type", String)
], BannerPreset.prototype, "name", void 0);
_ts_decorate([
    observable,
    _ts_metadata("design:type", Boolean)
], BannerPreset.prototype, "needsPro", void 0);
_ts_decorate([
    observable,
    _ts_metadata("design:type", String)
], BannerPreset.prototype, "description", void 0);
_ts_decorate([
    observable,
    _ts_metadata("design:type", typeof Array === "undefined" ? Object : Array)
], BannerPreset.prototype, "tags", void 0);
_ts_decorate([
    observable,
    _ts_metadata("design:type", Object)
], BannerPreset.prototype, "settings", void 0);
export { BannerPreset };
